export const valueTypes = {
  CURRENCY: 'Amount',
  QUANTITY: 'Quantity',
}
